import React from 'react';
import './StudentHero.css';
import SideQuestStatusCard from './SideQuestStatusCard';
import HeroWelcomeCard from './HeroWelcomeCard';

const StudentHero = ({ profile, subjects, onStartQuiz, onStartQuest }) => {
  return (
    <header className="compact-student-hero">
      <HeroWelcomeCard profile={profile} onStartQuiz={onStartQuiz} subjects={subjects} />
      <SideQuestStatusCard onStartQuest={onStartQuest}/>
    </header>
  );
};

export default StudentHero;